﻿import React, { useState, useEffect } from 'react';
import { pushToDataLayer } from '../dataLayer'

export const TextareaWithLabel = (props) => {
  const wrappingClass = `single-step__section single-step__section--textarea }`;

  const error = props.value && props.value.error;
  const value = props.value && props.value.text;
  const defaultValue = props.defaultText;

  const onChangeHandler = (e) => { 
    if(props.onChange) {
      props.onChange(props.index, e.target.value);
      pushToDataLayer({ event: 'input_change', label: props.text, value: e.target.value }, 1000);
    } else {
      if (!props.setValue)
        return;

      props.setValue({...props.value, text: e.target.value})
    }
  }

  return (
    <div className={wrappingClass}>
      <label>
        {props.text && <span className="single-step__section__label">{props.text}<span>{props.description && ` (${props.description})`}</span></span>}
        <textarea
          aria-invalid={error ? true : null}
          onKeyDown={(e) => props.keyDown ? props.keyDown(e) : null}
          placeholder={props.placeholder}
          autoComplete={props.autocomplete}
          value={value}
          onChange={onChangeHandler}
          defaultValue={defaultValue}
          disabled={props.disabled}
          maxLength={props.maxLength}
          rows="5" />
        {error && <div className="validation-error">{error}</div>}
      </label>
    </div>
  );
}